import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import CheckIcon from '@mui/icons-material/Check';
import { uploadFilesToFilestorage } from "../../../utils/media-files";
import MyRichTextEditor from "../../../components/MyRichTextEditor";

interface TemplateModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (htmlContent: string) => Promise<string | null>; 
    initialUrl?: string;
}

interface PendingImage {
    file: File;
    localUrl: string;
}

const EMAIL_VARIABLES = [
    { code: "{{Nombre}}", description: "Nombre completo del colaborador" },
    { code: "{{Fecha}}", description: "Fecha del onomástico (DD/MM)" },
    { code: "{{Empresa}}", description: "Nombre de la organización" }
];

const TemplateEditorModal: React.FC<TemplateModalProps> = ({ open, onClose, onSave, initialUrl }) => {
    const [htmlContent, setHtmlContent] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    
    const [pendingImages, setPendingImages] = useState<PendingImage[]>([]);

    useEffect(() => {
        if (open && initialUrl) {
            fetch(initialUrl).then(res => res.text()).then(text => setHtmlContent(text));
        } else if (open) {
            setHtmlContent("<p>¡Hola! Te deseamos un excelente cumpleaños...</p>"); 
            setPendingImages([]);
        }
    }, [open, initialUrl]);

    const handleRegisterLocalImage = (file: File, localUrl: string) => {
        setPendingImages(prev => [...prev, { file, localUrl }]);
    };

    const handleSave = async () => {
        setLoading(true);
        let finalHtml = htmlContent;

        try {
            for (const item of pendingImages) {
                if (finalHtml.includes(item.localUrl)) {
                    const result = await uploadFilesToFilestorage([item.file], () => {}, false);
                    
                    if (result && result.filestorageData && result.filestorageData[0]) {
                        const s3PublicUrl = result.filestorageData[0].FileName;
                        finalHtml = finalHtml.replaceAll(item.localUrl, s3PublicUrl);
                    }
                }
            }

            await onSave(finalHtml);
            onClose();
        } catch (error) {
            console.error("Error procesando los recursos de la plantilla", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ fontWeight: '700' }}>
                Diseñador Visual de Plantilla de Correo
            </DialogTitle>
            <DialogContent dividers>
                <MyRichTextEditor 
                    value={htmlContent} 
                    onChange={setHtmlContent} 
                    variables={EMAIL_VARIABLES}
                    onLocalImageAdded={handleRegisterLocalImage}
                />
            </DialogContent>
            <DialogActions style={{ padding: "1rem" }}>
                <Button onClick={onClose} color="primary" disabled={loading}>
                    Cancelar
                </Button>
                <Button 
                    onClick={handleSave} 
                    color="primary" 
                    variant="contained"
                    disabled={loading}
                    startIcon={<CheckIcon />}
                >
                    Guardar Cambios
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TemplateEditorModal;